import Axios from "axios"

export default {

  /**
   * 参数详情
   */
  paramInfo() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/searchField`);
  },

  /**
   * 列表
   * @param {*} gender 
   * @param {*} age_range_min 
   * @param {*} age_range_max 
   * @param {*} page
   */
  listPage(
    customer_type,
    visit_first_datetime_start,
    visit_first_datetime_end,
    visit_last_datetime_start,
    visit_last_datetime_end,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/page`, {
      params: {
        customer_type,
        visit_first_datetime_start,
        visit_first_datetime_end,
        visit_last_datetime_start,
        visit_last_datetime_end,
        page
      }
    });
  },

  /**
   * 详情
   * @param {*} customerId 
   */
  info(
    customerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/${customerId}`);
  },

  /**
   * 编辑
   * @param {*} customerId 
   * @param {*} project_customer_attr_name 
   * @param {*} project_customer_attr_gender 
   * @param {*} project_customer_attr_age 
   * @param {*} project_customer_attr_other 
   */
  edit(
    customerId,
    project_customer_attr_other
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/projectCustomer/saveCustomerAttr/${customerId}`, {
      project_customer_attr_other
    });
  },

  /**
   * 轨迹列表
   * @param {*} customerId 
   */
  logList(
    customerId
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/${customerId}/project/visit`);
  },

  /**
   * 轨迹详情列表
   * @param {*} customerId
   * @param {*} day 
   */
  logInfoList(
    customerId,
    day
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/${customerId}/project/visit/day/${day}`);
  },

  /**
   * 到访客户列表
   * @param {*} visit_date_start 
   * @param {*} visit_date_end 
   * @param {*} page 
   */
  visitListPage(
    visit_date_start,
    visit_date_end,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/projectCustomer/visit/page`, {
      params: {
        visit_date_start,
        visit_date_end,
        page
      }
    });
  }

}